export default "/kiban/_next/static/images/RoHS-832afde3b3c3a4e529c37c36d085c531.png";